import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { usePhotoUrl } from '@/hooks/use-photo'
import { BrandMark } from '@/components/app/brand-mark'

interface BusinessLogoProps {
    logo: string | null | undefined
    name: string
    className?: string
}

/* The business logo from settings, or the Washline mark when none is set. */
export const BusinessLogo: FC<BusinessLogoProps> = ({ logo, name, className }): ReactNode => {
    const url = usePhotoUrl(logo)

    if (!url) return <BrandMark className={cn('size-10', className)} />

    return (
        <span className={cn('inline-grid size-10 shrink-0 place-items-center overflow-hidden rounded-xl border border-border bg-white', className)}>
            <img src={url} alt={`${name} logo`} className='size-full object-contain' />
        </span>
    )
}
